export default function createCustomPropType(isRequired, validatorFn) {
  return (props, propName, componentName) => {
    const prop = props[propName];
    if (prop === undefined && isRequired) {
      throw new Error(`The prop \`${propName}\` is marked as required in \`${componentName}\`, but its value is \`undefined\`.`);
    } else {
      validatorFn(props, propName, componentName)
    }
  }
}
